import type { PropsWithChildren } from 'react';
import React, { createContext, useMemo } from 'react';

import type { Logger } from '@feature-hub/logger';
import type {
  LocaleService,
  TrackingService,
  VideoService,
  OneGraphService,
} from './feature-service-types';

interface FeatureAppEnv {
  featureAppId: string;
  featureAppName?: string;
}

export interface ContextState {
  readonly featureAppEnv: FeatureAppEnv;
  readonly localeService: LocaleService;
  readonly loggerService?: Logger;
  readonly trackingService?: TrackingService;
  readonly videoService?: VideoService;
  readonly oneGraphService: OneGraphService;
}

export const Context = createContext<ContextState>({} as ContextState);

export interface ContextProviderProps {
  readonly featureAppEnv: FeatureAppEnv;
  readonly localeService: LocaleService;
  readonly loggerService?: Logger;
  readonly trackingService?: TrackingService;
  readonly videoService?: VideoService;
  readonly oneGraphService: OneGraphService;
}

const ContextProvider = ({
  children,
  featureAppEnv,
  localeService,
  loggerService: logger,
  trackingService,
  videoService,
  oneGraphService,
}: PropsWithChildren<ContextProviderProps>) => {
  const value = useMemo(
    () => ({
      featureAppEnv,
      localeService,
      loggerService: logger,
      trackingService,
      videoService,
      oneGraphService,
    }),
    [],
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};
export default ContextProvider;
